import { observer } from 'mobx-react-lite';
import { ReactNode } from 'react';
import { QueueStateContext } from '../../queues/context/queue-state-context';
import { useIntegratedBoloQueueStore } from './use-integrated-bolo-queue-store';

export const BoloQueueStateProvider = observer(function BoloQueueStateProvider({
    children,
}: {
    children: ReactNode;
}) {
    const store = useIntegratedBoloQueueStore();
    return <QueueStateContext.Provider value={store}>{children}</QueueStateContext.Provider>;
});
